/**
 * plattformSettings.ts — Plattform-Einstellungen beim Öffnen der App laden
 * (18.10.2026).
 *
 * Preise, Impressum, AGB/Datenschutz und Startseiten-Texte pflegt der Admin
 * unter „Plattform-Einstellungen" (Tabelle `plattform_settings`, für alle
 * lesbar — auch ohne Anmeldung). Vorher wurden sie erst nach dem Login
 * geladen; neue Besucher sahen Standardwerte.
 *
 * @module lib/plattformSettings
 */

import { db } from './supabase.js';
import { initPlattformSettings } from '../config/constants.js';
import type { PlattformSettings } from '../types.js';

/**
 * Einstellungen aus der Datenbank holen und anwenden. Bei einem Fehler
 * (offline, Datenbank nicht erreichbar) bleibt alles, wie es ist —
 * zuletzt gespeicherte Werte oder Standardwerte. Ein leerer Fehler-Rückgabewert
 * überschreibt also nie die gespeicherten Werte.
 *
 * @returns true, wenn neue Werte angewendet wurden
 */
export async function ladePlattformSettings(): Promise<boolean> {
  try {
    const r = await db.getPlattformSettings();
    if (r.error || !r.data) return false;
    initPlattformSettings(r.data as PlattformSettings);
    return true;
  } catch {
    return false;
  }
}
